import React, { useState } from 'react';
import { Row, Col, Form, Pagination, Button } from 'react-bootstrap';
import './FeedbacksComponent.css';
import { ICONS } from '../../constants/constants';
import { Link, Navigate, useNavigate } from 'react-router-dom';

const FeedbacksComponent = ({ supplierId, averageRating, totalReviews, reviews, title, showLink, enablePagination }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState(''); // State for selected sorting option
  const reviewsPerPage = 5; // Set the number of reviews per page
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const handlePageChange = (page) => setCurrentPage(page);

  // Handle sorting change based on rating or date
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  // Function to render stars based on the rating
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(<img src={ICONS.coloredStar} key={i} className="star filled" />);
      } else if (i - rating < 1) {
        stars.push(<img src={ICONS.coloredStar} key={i} className="star filled" />);
      } else {
        stars.push(<img src={ICONS.simpleStar} key={i} className="star empty" />);
      }
    }
    return stars;
  };

  const safeAverageRating = Number(averageRating) || 0;

  // Sorting logic based on the selected option
  const sortedReviews = () => {
    let sorted = [...reviews];
    if (sortBy === 'highest') {
      sorted.sort((a, b) => b.rating - a.rating); // Sort by highest rating
    } else if (sortBy === 'lowest') {
      sorted.sort((a, b) => a.rating - b.rating); // Sort by lowest rating
    } else if (sortBy === 'newest') {
      sorted.sort((a, b) => new Date(b.ratingDate || b.ratingdate) - new Date(a.ratingDate || a.ratingdate)); // Sort by newest
    } else if (sortBy === 'oldest') {
      sorted.sort((a, b) => new Date(a.ratingDate || a.ratingdate) - new Date(b.ratingDate || b.ratingdate)); // Sort by oldest
    }
    return sorted;
  };

  const displayedReviews = sortedReviews().slice((currentPage - 1) * reviewsPerPage, currentPage * reviewsPerPage);

  const navigate = useNavigate();
  const goToFeedbackDetail = () => {
    
    navigate(`/feedbacks/${supplierId}`, { state: { id: supplierId } });

  };

  return (
    <div className="feedbacks">
      <Row className='py-1'>
        <Col lg={6}><strong>{title}</strong></Col>
        <Col lg={6}>
          <div className="d-flex justify-content-end align-items-center">
            <Form.Select aria-label="Sort Options" className="w-auto" onChange={handleSortChange}>
              <option value="" disabled selected hidden>Sort by:</option>
              <option value="highest">Highest Rating</option>
              <option value="lowest">Lowest Rating</option>
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

      <div className="average-rating">
        <Row>
          <Col lg={6}>
            {safeAverageRating.toFixed(1)}
            <div className="stars ms-2">{renderStars(Math.round(safeAverageRating))}</div>
          </Col>
          <Col lg={6} className='text-end'>
            {showLink ? (
              <p onClick={goToFeedbackDetail} className="view-profile-link">View All</p>
            ) : (
              <div className='total-reviews'>{totalReviews} Reviews</div>
            )}
          </Col>
        </Row>
      </div>

      {displayedReviews.map((review, index) => (
        <div key={index} className="review-item p-3 border">
          <div className="stars">
            {renderStars(review.rating)}
          </div>
          <p className="review-comment">{review.comment}
            <br />
            <span className="reviewer-name">{review.customerName}</span>
            <span className="rating-date ms-5">{review.ratingDate || review.ratingdate}</span>
          </p>
        </div>
      ))}

      {enablePagination && totalPages > 1 && (
        <Pagination className="justify-content-center">
          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      )}
    </div>
  );
};

export default FeedbacksComponent;
